import React from "react";
import styled, { css, keyframes } from "styled-components";
import { Message as MessageInterface } from "../machines/chatbotMachine";

const Message = (props: MessageInterface) => {
  return (
    <Wrapper {...props}>
      <Container {...props}>{props.message}</Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  ${(props: MessageInterface) =>
    props.sender === "user"
      ? css`
          justify-content: flex-end;
          padding-left: 24px;
        `
      : css`
          justify-content: flex-start;
          padding-right: 24px;
        `}
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  ${(props: MessageInterface) =>
    props.sender === "user"
      ? css`
          background-color: #3bceac;
          color: #ffffff;
          border-radius: 16px 16px 0px 16px;
        `
      : css`
          background-color: #c6d7eb;
          border-radius: 16px 16px 16px 0;
          color: #000000;
        `}
  padding: 16px;
  font-size: 16px;
  letter-spacing: 0.02em;
  line-height: 140%;
  animation: 0.25s ${fadeIn} ease-out;
`;

export default Message;
